<mat-toolbar class="titulopartes">Admissão</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlex="35%" fxFlexOffset="20px">
        <input matInput maxlength="250" name="nome" placeholder="Matrícula:" required
            [(ngModel)]="funcionario.matricula">
    </mat-form-field>

    <mat-form-field fxFlex="20%">
        <input matInput name="dataAdmissao" [matDatepicker]="dataAdmissao" placeholder="Data de Admissão:"
            [(ngModel)]="funcionario.dataAdmissao" required (input)="onMascaraDataInput($event)">
        <mat-datepicker-toggle matSuffix [for]="dataAdmissao"></mat-datepicker-toggle>
        <mat-datepicker #dataAdmissao></mat-datepicker>
    </mat-form-field>

    <mat-form-field fxFlex="20%">
        <input matInput name="dataDemissao" [matDatepicker]="dataDemissao" placeholder="Data de Demissão:"
            [(ngModel)]="funcionario.dataDemissao" (input)="onMascaraDataInput($event)">
        <mat-datepicker-toggle matSuffix [for]="dataDemissao"></mat-datepicker-toggle>
        <mat-datepicker #dataDemissao></mat-datepicker>
    </mat-form-field>

</div>

<mat-toolbar class="titulopartes">Dados Funcionais</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlex="45%" fxFlexOffset="20px">
        <mat-label>Tipo de Funcionário:</mat-label>
        <mat-select [(ngModel)]="funcionario.tipoFuncionario" name="tipoFuncionario"
            (selectionChange)="zerarCamposEntrevista()">
            <mat-option *ngFor="let m of tiposFuncionario.tipos" [value]="m.tipo">
                {{m.descricao}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div *ngIf="mostrarCamposEntrevista()">
    <mat-toolbar class="titulopartes">Entrevista</mat-toolbar>

    <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
        <mat-form-field fxFlex="96%" fxFlexOffset="20px">
            <mat-label>Usuário Responsável pela Entrevista:</mat-label>
            <mat-select [(ngModel)]="funcionario.funcionarioEntrevistador.id" name="funcionarioEntrevistador">
                <mat-option *ngFor="let m of funcionarios" [value]="m.id">
                    {{m.pessoasFisica.nome}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
        <mat-form-field fxFlexOffset="20px" fxFlex="20%">
            <input matInput name="dtHrEntrevista" [matDatepicker]="dtHrEntrevista" placeholder="Data da Entrevista:"
                [(ngModel)]="funcionario.dtHrEntrevista">
            <mat-datepicker-toggle matSuffix [for]="dtHrEntrevista"></mat-datepicker-toggle>
            <mat-datepicker #dtHrEntrevista></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
            <input matInput #horaInicio="ngModel" mat-hide-icons="calendar" type="time" name="horaInicio"
                placeholder="Hora:" [(ngModel)]="funcionario.horaEntrevista">
        </mat-form-field>

        <div fxLayout="row" fxLayoutGap="20px" fxFlex="70%" fxLayoutAlign="start center">
            <mat-form-field fxFlex="15%">
                <input currencyMask name="salarioPretendido" placeholder="Salário Pretendido:" matInput
                    [(ngModel)]="funcionario.salarioPretendido"
                    [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                <span matPrefix>R$&nbsp;</span>
            </mat-form-field>
        </div>
    </div>


    <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
        <mat-form-field fxFlex="45%" fxFlexOffset="20px">
            <mat-label>Parecer:</mat-label>
            <mat-select [(ngModel)]="funcionario.parecerEntrevistador" name="parecerEntrevistador">
                <mat-option *ngFor="let m of listaParecer" [value]="m.id">
                    {{m.descricao}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex="45%" fxFlexOffset="20px">
            <mat-label>Conclusão do Parecer:</mat-label>
            <mat-select [(ngModel)]="funcionario.conclusaoParecer" name="conclusaoParecer">
                <mat-option *ngFor="let m of conclusaoDoParecer" [value]="m.id">
                    {{m.descricao}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div fxLayout="row" fxFlexFill>
        <mat-form-field fxFlexOffset="20px" fxFlex="95%" style="margin-bottom: 0px" appearance="outline">
            <mat-label>Descrição do Parecer:</mat-label>
            <textarea matInput name="observacoes" [(ngModel)]="funcionario.descricaoParecerEntrevistador"
                cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200"></textarea>
        </mat-form-field>
    </div>
</div>

<!-- UNIDADE -->
<mat-toolbar class="titulopartes">Unidade</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlex="95%" fxFlexOffset="20px">
        <mat-label>Selecione a Unidade</mat-label>
        <mat-select name="unidade" [(ngModel)]="funcionario.unidade.idUnidade" required>
            <mat-option *ngFor="let u of unidades" [value]="u.idUnidade">
                {{u.nomeUnidade}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>



<!-- EMPRESA -->
<mat-toolbar class="titulopartes">Empresa</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlex="95%" fxFlexOffset="20px">
        <mat-label>Selecione a Empresa</mat-label>
        <mat-select name="empresaFuncionario" [(ngModel)]="funcionario.empresaFuncionario.id"
            [required]="!funcionario.unidade.idUnidade">
            <mat-option *ngFor="let u of empresas" [value]="u.id">
                {{u.nomeFantasia}}
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>

<!-- CARGO -->
<mat-toolbar class="titulopartes">Cargo</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlex="85%" fxFlexOffset="20px">
        <mat-label>Selecione o Cargo</mat-label>
        <mat-select name="cargo" [(ngModel)]="funcionario.cargo.id" required (selectionChange)="onCargoChange($event.value)">
            <mat-option *ngFor="let u of cargos" [value]="u.id">
                {{u.nome}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex="15%">
        <mat-label>CBO</mat-label>
        <mat-select [(ngModel)]="funcionario.cargo.cbo.id" name="cbo" [disabled]="true">
            <mat-option></mat-option>
            <mat-option *ngFor="let m of cbos" [value]="m.id">
                    {{m.numero}} - {{m.descricaoTipo}}
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>


<!-- DEPARTAMENTO -->
<mat-toolbar class="titulopartes">Departamento</mat-toolbar>
<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlex="65%" fxFlexOffset="20px">
        <mat-label>Selecione o Departamento</mat-label>
        <mat-select name="departamento" [(ngModel)]="funcionario.departamento.idDepartamento">
            <mat-option *ngFor="let u of departamentos" [value]="u.idDepartamento">
                {{u.nmDepartamento}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-checkbox (change)="atualizarDescontaValeTransporte()"
        color="primary" 
        name="descontaValeTransporte" 
        [(ngModel)]="descontaValeTransporte" 
        class="custom-checkbox"
        style="margin: 0 30px 0 15px;">
        Vale Transporte
    </mat-checkbox>

    <mat-checkbox (change)="atualizarDescontaPecunia()"
        color="primary" 
        name="descontaPecunia" 
        [(ngModel)]="descontaPecunia" 
        class="custom-checkbox"
        style="margin: 0 30px 0 15px;">
        Pecúnia
    </mat-checkbox>
</div>

<!-- JORNADA DE TRABALHO -->
<mat-toolbar class="titulopartes">Jornada de Trabalho</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlexOffset="20px" >
        <input matInput [(ngModel)]=funcionario.horaInicioJornada mat-hide-icons="calendar" type="time" name="horaInicioJornada" placeholder="Hora Início:">
    </mat-form-field>

    <mat-form-field>
        <input matInput [(ngModel)]=funcionario.horaFimJornada mat-hide-icons="calendar" type="time" name="horaFimJornada" placeholder="Hora Fim:">
    </mat-form-field>

</div>

<!-- INFORMACOES COMPLEMENTARES -->
<mat-toolbar class="titulopartes">Informações Complementares</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <!-- #EMAIL  -->
    <mat-form-field fxFlexOffset="20px" fxFlex="60%">
        <input maxlength="100" [(ngModel)]=funcionario.pessoasFisica.emailProfissional matInput type="emailProfissional" name="email"
            placeholder="Email Profissional:" email>
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlex="80%" fxFlexOffset="20px">
        <input matInput maxlength="100" name="descMotivoDemissao" 
               placeholder="Descrição Motivo Demissão"
               [(ngModel)]="funcionario.descMotivoDemissao">
    </mat-form-field>

    <mat-form-field fxFlex="165px">
        <input matInput name="dataUltimoExame" [matDatepicker]="dataUltimoExame" placeholder="Data último exame"
               [(ngModel)]="funcionario.dataUltimoExame" (input)="onMascaraDataInput($event)">
        <mat-datepicker-toggle matSuffix [for]="dataUltimoExame"></mat-datepicker-toggle>
        <mat-datepicker #dataUltimoExame></mat-datepicker>
    </mat-form-field>
</div>

<escolaridade [pessoaFisica]="funcionario.pessoasFisica"></escolaridade>
<alocacao [funcionario]="funcionario"></alocacao>